import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React from 'react'

const ModelDeleteSelectedItems = ({ confirmOpen, handleCloseConfirm, isArabic, selectedCount, isBulkDeleting, handleConfirmDelete }) => {
  return (
    <>
      <Dialog
        open={confirmOpen}
        onClose={handleCloseConfirm}
        aria-labelledby="bulk-delete-dialog-title"
        aria-describedby="bulk-delete-dialog-description"
      >
        <DialogTitle id="bulk-delete-dialog-title">
          {isArabic ? 'تأكيد حذف العناصر المحددة' : 'Confirm bulk delete'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="bulk-delete-dialog-description">
            {isArabic
              ? `هل أنت متأكد أنك تريد حذف ${selectedCount} عنصر/عناصر محددة؟ لا يمكن التراجع عن هذه العملية.`
              : `Are you sure you want to delete ${selectedCount} selected item(s)? This action cannot be undone.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseConfirm}
            disabled={isBulkDeleting}
            variant="outlined"
          >
            {isArabic ? 'إلغاء' : 'Cancel'}
          </Button>
          <Button
            onClick={handleConfirmDelete}
            color="error"
            variant="contained"
            disabled={isBulkDeleting}
          >
            {isBulkDeleting
              ? isArabic
                ? 'جاري الحذف...'
                : 'Deleting...'
              : isArabic
                ? 'تأكيد الحذف'
                : 'Confirm delete'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ModelDeleteSelectedItems